'use strict';

import {invitationModel} from "../../models/invitationmodel.js";
import {communicationSubjectModel} from "../../models/communicationsubjectmodel.js";

export class InvitationPreviewCtrl
{
	$scope;
	$filter;
	jsDataService;
	editUrl;
	changeUrl;
	cancelChangeUrl;
	pendingUrl;
	removeUrl;
	confirmUrl;
	item = {};
	sections = {};
	applicate = {
		active: 1
	};
	
	constructor($scope, $filter, $mdDialog, jsDataService){
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.$mdDialog = $mdDialog;
		this.jsDataService = jsDataService;
		this.classif = this.jsDataService.get('cfgClassif', {});
		this.sections = this.jsDataService.get('cfgSections', {});
		this.item = new invitationModel(jsDataService.get('invitation', {}), $filter, jsDataService);
		this.applicate = this.jsDataService.get('cfgApplicate', {active: false});
		this.editUrl = this.jsDataService.get('editUrl', '');
		this.changeUrl = this.jsDataService.get('changeUrl', '');
		this.cancelChangeUrl = this.jsDataService.get('cancelChangeUrl', '');
		this.pendingUrl = this.jsDataService.get('pendingUrl', '');
		this.removeUrl = this.jsDataService.get('removeUrl', '');
		this.confirmUrl = this.jsDataService.get('confirmUrl', '');
	}
	
	fieldValue(field){
		if(typeof(this.item[field]) === 'undefined'){
			return '';
		}
		let val = this.item.getValue(field);
		switch(field){
			case 'objectives':
				return this.$filter('nl2br')(val);
			case 'duration_extension':
				return this.$filter('nl2br')(val).length > 0 ? this.$filter('nl2br')(val) : 'Not applicable';
		}
		return val;
	}
	
	sectionFieldVisible(fldCfg){
		if(!fldCfg.show){
			return false;
		}
		if(typeof(this.item[fldCfg.idkey+'_on']) !== 'undefined' && (this.item[fldCfg.idkey+'_on'] != 1 || false === this.item[fldCfg.idkey+'_on'])){
			return false;
		}
		return true;
	}
	
	sectionFieldValue(fldCfg){
		return this.fieldValue(fldCfg.idkey);
	}
	
	sectionDisplay(section){
		if(typeof(section.fields) !== 'undefined' && Object.values(section.fields).some((item)=>{
			return item.show === true;
		})){
			return true;
		}
		if(this.item.hasOptionalFields(section.idkey)){
			return true;
		}
		return false;
	}
	
	canApplicate(){
		return this.applicate.active;
	}
	
	applicateNew(){
		if(this.canApplicate() && this.applicate.url !== ''){
			this.$scope.basicHttpConfigProcess({
				url: this.applicate.url,
				method: 'GET',
			});
		}
	}

	change(){
		if(this.changeUrl !== ''){
			this.$scope.basicHttpConfigProcess({
				url: this.changeUrl,
				method: 'GET'
			});
		}
	}
	
	pendingChange(ev){
		if(this.pendingUrl !== ''){
			const confirmTexts = this.jsDataService.get('pendingConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.pendingUrl,
					method: 'GET',
					responseType: 'json'
				}).then((results) => {
					if(results.data.success){

					}
				});
			}, () => {});
		}
	}
	
	confirm(ev){
		if(typeof(this.removeUrl) !== 'undefined' && this.confirmUrl !== ''){
			const confirmTexts = this.jsDataService.get('confirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.confirmUrl,
					method: 'GET',
					responseType: 'json'
				}).then((results) => {
					if(results.data.success){

					}
				});
			}, () => {});
		}
	}
	
	remove(ev){
		if(typeof(this.removeUrl) !== 'undefined' && this.removeUrl !== ''){
			const confirmTexts = this.jsDataService.get('removeConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.removeUrl,
					method: 'GET',
					responseType: 'json'
				}).then((results) => {
					if(results.data.success){

					}
				});
			}, () => {});
		}
	}
	
	cancelChange(ev){
		if(typeof(this.cancelChangeUrl) !== 'undefined' && this.cancelChangeUrl !== ''){
			const confirmTexts = this.jsDataService.get('removeConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.cancelChangeUrl,
					method: 'GET',
					responseType: 'json'
				}).then((results) => {
					if(results.data.success){

					}
				});
			}, () => {});
		}
	}

	publish(ev){
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", "jsDataService", this.publishDialogCtrl],
			templateUrl: 'invitations/publish.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose:false,
			fullscreen: true,
			locals: {

			}
		}).then((results) => {
			this.$scope.$root.basicHttpConfigProcess({
				url: this.item.status_url,
				method: 'POST',
				responseType: 'json',
				data: results
			});
		}, () => {});

	}

	publishChange(ev){
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", "jsDataService", this.publishChangeDialogCtrl],
			templateUrl: 'invitations/publish_change.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose:false,
			fullscreen: true,
			locals: {
				
			}
		}).then((results) => {
			if(typeof(this.item.status_url) !== 'undefined'){
				this.$scope.$root.basicHttpConfigProcess({
					url: this.item.status_url,
					method: 'POST',
					responseType: 'json',
					data: results
				});
			}
		}, () => {});
		
	}

	rejectChange(ev){
		if(typeof(this.jsDataService.get('rejectChangeUrl')) !== 'undefined' && this.jsDataService.get('rejectChangeUrl') !== ''){
			const confirmTexts = this.jsDataService.get('rejectChangeConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('rejectChangeUrl'),
					method: 'GET',
					responseType: 'json'
				}).then((results) => {
					if(results.data.success){

					}
				});
			}, () => {});
		}
	}

	publishDialogCtrl($scope, $mdDialog, jsDataService){
		$scope.reject = function() {
			if(typeof(jsDataService.get('rejectUrl')) !== 'undefined' && jsDataService.get('rejectUrl') !== ''){
				$scope.$root.basicHttpConfigProcess({
					url: jsDataService.get('rejectUrl'),
					method: 'GET'
				}).then((response) => {
					if(response.data.success){

					}
				}, () => {});
			}
			$mdDialog.hide();
		};

		$scope.publish = function() {
			if(typeof(jsDataService.get('publishUrl')) !== 'undefined' && jsDataService.get('publishUrl') !== ''){
				$scope.$root.basicHttpConfigProcess({
					url: jsDataService.get('publishUrl'),
					method: 'GET'
				}).then((response) => {
					if(response.data.success){

					}
				}, () => {});
			}
			$mdDialog.hide();
		};
		$scope.close = function() {
			$mdDialog.cancel();
		};
	}

//	publishChangeDialogCtrl($scope, $mdDialog, jsDataService){
//		$scope.reject = function() {
//			if(typeof(jsDataService.get('rejectChangeUrl')) !== 'undefined' && jsDataService.get('rejectChangeUrl') !== ''){
//				$scope.$root.basicHttpConfigProcess({
//					url: jsDataService.get('rejectChangeUrl'),
//					method: 'GET'
//				}).then((response) => {
//					if(response.data.success){
//
//					}
//				}, () => {});
//			}
//			$mdDialog.hide();
//		};
//
//		$scope.publish = function() {
//			if(typeof(jsDataService.get('publishChangeUrl')) !== 'undefined' && jsDataService.get('publishChangeUrl') !== ''){
//				$scope.$root.basicHttpConfigProcess({
//					url: jsDataService.get('publishChangeUrl'),
//					method: 'GET'
//				}).then((response) => {
//					if(response.data.success){
//
//					}
//				}, () => {});
//			}
//			$mdDialog.hide();
//		};
//		$scope.close = function() {
//			$mdDialog.cancel();
//		};
//	}

	openSubjectDialog(ev){
		const subject = new communicationSubjectModel({
			message: ''
		});


		this.$mdDialog.show({
			controller: ['$scope', '$mdDialog', 'jsDataService', 'subject', this.subjectEditorCtrl],
			controllerAs: 'ctrl',
			templateUrl: 'invitations/publish_editor.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: false,
			fullscreen: true,
			locals: {
				subject: subject
			}
		}).then((results) => {
			if(typeof(this.jsDataService.get('publishChangeUrl')) !== 'undefined' && this.jsDataService.get('publishChangeUrl') !== ''){
					this.$scope.$root.basicHttpConfigProcess({
					url: this.jsDataService.get('publishChangeUrl'),
					method: 'POST',
					responseType: 'json',
					data: results
				});
			}
		}, (results) => {
			console.log(results);
		});
	}

	subjectEditorCtrl($scope, $mdDialog, jsDataService, subject){
		$scope.subject = angular.copy(subject);
		$scope.subjectForm;
//		$scope.uploadUrl = jsDataService.get('cfgUploadUrl');
		$scope.close = function() {
			$mdDialog.cancel();
		};

		$scope.save = function() {
			$mdDialog.hide($scope.subject);
		};

//		$scope.fileAdded = function ($file) {
//			const file = {
//				id: '0',
//				file_id: '0',
//				name: $file.name,
//				isFlow: true,
//				flowFile: $file,
//			};
//
//			$scope.subject.attachment.push(file);
//			return true;
//		};
//
//		$scope.fileSubmitted = function() {
//			$scope.subject.flow.upload();
//		};
//
//		$scope.fileUploaded = function ($file, $message) {
//			const file = $scope.subject.attachment.find(f => f.flowFile?.uniqueIdentifier === $file.uniqueIdentifier);
//
//			if(!file) {
//				return;
//			}
//
//			try {
//				const response = JSON.parse($message);
//				file.file_id = response.fileId;
//				$scope.subjectForm['attachment'].$setViewValue(Date.now());
//			} catch(err) {
//
//			}
//		};
//
//		$scope.removeFile = function (file) {
//			$scope.subject.attachment = $scope.subject.attachment.filter(f => f !== file);
//			$scope.subjectForm['attachment'].$setViewValue(Date.now());
//		};
//
//		$scope.isValid = function (){
//			return !$scope.subject.flow.isUploading();
//		};

		$scope.getSaveData = function() {
			return {
				message: $scope.subject.message
//				attachment: $scope.subject.attachment.map(({id, file_id}) => ({id, file_id})),
			};
		};
	}
}